import { generatePath } from "react-router-dom";

import { LinkModule } from ".";

import { BusinessSlugTypes, DynamicFormCriteriaFlowScope } from "config";

type BeneficiaryLinkState = {
  flowScope: DynamicFormCriteriaFlowScope;
};

export const beneficiaryFlowLink = (
  scope: "policy_holder",
  state: Record<string, unknown> = {}
): LinkModule<BeneficiaryLinkState> => {
  const lineOfBusinessMap: Record<typeof scope, BusinessSlugTypes> = {
    policy_holder: "wysh-insurance",
  };

  const lineOfBusiness = lineOfBusinessMap[scope];
  const route = "/beneficiary/:lineOfBusiness";
  const pathname = generatePath(route, { lineOfBusiness });

  return {
    pathname,
    state: {
      ...state,
      flowScope: scope,
    },
  };
};
